export default __webpack_public_path__ + "static/flag-se-ce9f9a8143d98629595e5a68726d9b9d.svg";